/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as techInventoryActions from 'actions/techInventoryActions';
import EquipmentSearch from 'equipmentComponents/EquipmentSearch';
import Footer from 'containers/Footer';
import SearchIcon from 'material-ui/svg-icons/action/search';

export class EquipmentSearchPage extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {

        const { techData, techInventoryActions } = this.props;

        const inventorySearch = techData.getIn(['inventorySearch']);

        return (
            <div>
                <h5 style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: '1em', justifyContent: 'center' }}>
                    <SearchIcon style={{ verticalAlign: 'middle', marginRight: 8 }} />
                    Equipment Search
                </h5>
                <EquipmentSearch
                    inventorySearch={inventorySearch}
                    techInventoryActions={techInventoryActions} />
                <Footer /></div>
        );
    }
}

EquipmentSearchPage.propTypes = {
    techData: PropTypes.object.isRequired,
    techInventoryActions: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {

        techData: state.get('techData')

    };
}

function mapDispatchToProps(dispatch) {
    return {
        techInventoryActions: bindActionCreators(techInventoryActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentSearchPage);


// WEBPACK FOOTER //
// ./src/containers/pages/EquipmentSearchPage.js